import _ from 'lodash';
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import AppBar from '@material-ui/core/AppBar';
import Toolbar from '@material-ui/core/Toolbar';
import Typography from '@material-ui/core/Typography';
import { withStyles } from '@material-ui/core/styles';
import withWidth, { isWidthUp } from '@material-ui/core/withWidth';

import IconButton from '@material-ui/core/IconButton';
import MenuIcon from '@material-ui/icons/Menu';
import { Route, Switch } from 'react-router-dom';
import LeftDrawer from '../components/LeftDrawer';
import SavingDialog from '../components/dialogs/SavingDailog';
import ErrorDialog from '../components/dialogs/ErrorDialog';

//- containers
import TicketContainer from '../containers/Ticket/Ticket';
import LayoutContainer from '../containers/Layout';

//- Pages / Route
import Dashboard from './Dashboard';
import PickReport from './Driver/PickReport';
import SaveReport from './Driver/SaveReport';
import Users from './Users';
import Equipment from './Equipment';
import SaveEquipment from './Equipment/SaveEquipment';
import Location from './Location';
import SaveLocation from './Location/SaveLocation';
import SchedulingDashboard from './Scheduling/Dashboard';
import SchedulingSchedule from './Scheduling/Schedule';
import SaveUser from './SaveUser';
import SaveUserDriver from './SaveUserDriver';
import Administration from './Administration';
import AuthorizeBrowser from './Admin/AuthorizeBrowser';
import TicketList from './Ticket/List';
import BillingTicketList from './Ticket/BillingList';
import MyTicketList from './Ticket/MyList';
import TicketSave from './Ticket/Save';
import TicketAdvancedSearch from './Ticket/AdvancedSearch';
import TicketEmailDisplay from './Ticket/EmailDisplay';

import TicketCategoryList from './TicketCategory/List';
import TicketCategorySave from './TicketCategory/Save';

import TicketSchemaList from './TicketSchema/List';
import TicketSchemaSave from './TicketSchema/Save';

import EquipmentAssignmentList from './EquipmentAssignment/List';
import EquipmentAssignmentSave from './EquipmentAssignment/Save';

import TimeClockPermissionList from './TimeClockPermission/List';
import TimeClockPermissionSave from './TimeClockPermission/Save';

import AccountingDashboard from './Accounting/AccountingDashboard';
import SetupDriverRoomSchedule from './Scheduling/SetupDriverRoomSchedule';

import TimeClockDashboard from './TimeClock/Dashboard';
import TimeClockShiftReports from './TimeClock/ShiftReports';
import TimeClockExponentExport from './TimeClock/ExponentExport';
import TimeClockPaycomExport from './TimeClock/PaycomExport';
import ClockInAndOut from './ClockInAndOut';

import ArImporter from './Accounting/ArImporter';
import ShiftAudit from './TimeClock/ShiftAudit';
import DriverReports from './Reporting/DriverReports';
import DriverReportDetails from './Reporting/DriverReportDetails';

import PtoRequestDashboard from './Pto/Request/RequestDashboard';
import PtoRequestSave from './Pto/Request/Save';
import PtoRequestView from './Pto/Request/View';
import PtoApprovalDashboard from './Pto/Approval/ApprovalDashboard';
import PtoExportedDashboard from './Pto/Exported/ExportedDashboard';
import PtoScheduledDashboard from './Pto/Scheduled/ScheduledDashboard';
import PtoApprove from './Pto/Approval/Approve';

import LateAnalysis from './Reporting/LateAnalysis';
import LateAnalysisDetails from './Reporting/LateAnalysisDetails';
import TestMobile from './Test/TestMobile';

//import JourneyPlanSave from './JourneyPlan';
import JourneyPlans from './JourneyPlan/JourneyPlans';
import SaveJourneyPlan from './JourneyPlan/SaveJourneyPlan';
import DispatchDashboard from './Dispatch/DispatchDashboard';
import MobileNotifications from './Dispatch/MobileNotifications';
import DeviceEvents from './Dispatch/DeviceEvents';
import PastNotifications from './Dispatch/PastNotifications';
import ScheduleConfig from './Admin/ScheduleConfig';
import FleetConfig from './Admin/FleetConfig';
import GeoTabGroupConfig from './Admin/GeoTabGroupConfig';

//import SchemaBuilder from './Ticket/SchemaBuilder/SchemaBuilder';

const drawerWidth = 240;
const styles = (theme) => {
	return {
		root: {
			width: '100%',
			height: 'auto',
			zIndex: 1,
			//overflow: 'hidden',
			backgroundColor: '#e5e5e6',
		},
		appFrame: {
			//position: 'relative',
			zIndex: 10,
			transition: 'all 450ms cubic-bezier(0.23, 1, 0.32, 1) 0ms',
		},
		drawerFrame: {
			zIndex: 1,
			display: 'flex',
			transition: 'all 450ms cubic-bezier(0.23, 1, 0.32, 1) 0ms',
		},
		appBar: {
			width: '100%',
			position: 'relative',
		},
		drawerPaper: {
			//position: 'relative',
			//height: 'auto',
			//width: drawerWidth,
			width: drawerWidth,
			backgroundColor: '#2d2f31',
		},
		content: {
			display: 'flex',
			flexDirection: 'column',
			width: '100%',
			padding: 16,
			boxSizing: 'border-box',
			height: 'calc(100% - 56px)',
			//overflowX: 'scroll',
			[theme.breakpoints.up('md')]: {
				height: 'calc(100% - 64px)',
			},
		},
		hide: {
			display: 'none',
		},
		header: {
			fontWeight: 400,
			fontSize: 20,
			textTransform: 'uppercase',
		},
	};
};

const NoMatch = () => (
	<div>
		<h2>Invalid URL. Please check your URL or contact support</h2>
	</div>
);

class Layout extends Component {
	constructor(props) {
		super(props);
		this.state = {
			drawerOpen: false,
		};
	}

	componentDidMount() {
		const { myTickets, searchMyTickets, authUser, width } = this.props;
		this.setState({ drawerOpen: isWidthUp('md', width) });

		if (!myTickets && authUser) {
			searchMyTickets({
				assignedToUserId: authUser.userId,
			});
		}
	}

	componentDidUpdate(prevProps, prevState, snapshot) {
		const { myTickets, searchMyTickets, authUser, width } = this.props;

		if (this.props.width !== prevProps.width) {
			this.setState({ drawerOpen: isWidthUp('md', width) });
		}

		if (!myTickets && !prevProps.authUser && authUser) {
			searchMyTickets({
				assignedToUserId: authUser.userId,
			});
		}
	}

	handleDrawerToggle = () => {
		this.setState({ drawerOpen: !this.state.drawerOpen });
	};

	handleSavingClosed = () => {};

	continueSavingDialog = () => {
		this.props.clearSaving();
		this.props.history.push(this.props.onSuccessRedirectTo);
	};

	render() {
		// noinspection JSMismatchedCollectionQueryUpdate
		const {
			width,
			classes,
			savingStatus,
			savingMessage,
			savedMessage,
			errorMessages = [],
			myTickets,
		} = this.props;

		if (!myTickets) {
			return <div>Fetching your tickets...</div>;
		}

		const { drawerOpen } = this.state;

		const styles = {
			header: {
				paddingLeft: drawerOpen ? drawerWidth : 0,
			},
			container: {
				//margin: '80px 20px 20px 15px',
				paddingLeft: drawerOpen && isWidthUp('md', width) ? drawerWidth : 0,
			},
		};

		const isSavingOpen = !!savingStatus;
		const isErrorDialogOpen = errorMessages.length !== 0;

		return (
			<div className={classes.root}>
				<div className={classes.appFrame}>
					<AppBar className={classes.appBar} style={styles.header}>
						<Toolbar>
							<IconButton
								color="inherit"
								aria-label="open drawer"
								onClick={this.handleDrawerToggle}
							>
								<MenuIcon />
							</IconButton>

							<Typography variant="h6" color="inherit" noWrap className={classes.header}>
								Carrier Management System
							</Typography>
						</Toolbar>
					</AppBar>
				</div>
				<div className={classes.drawerFrame} style={styles.container}>
					<LeftDrawer
						drawerOpen={drawerOpen}
						drawerPaper={classes.drawerPaper}
						logout={this.props.logout}
						authUser={this.props.authUser}
						myTickets={myTickets}
					/>
					<div className={classes.content}>{this.renderRoutes()}</div>
				</div>

				<ErrorDialog
					onClose={this.props.clearError}
					errorMessages={errorMessages}
					open={isErrorDialogOpen}
				/>
				<SavingDialog
					open={isSavingOpen}
					onClose={this.handleSavingClosed}
					onContinue={this.continueSavingDialog}
					processingText={savingMessage}
					successText={savedMessage}
					status={savingStatus}
				/>
			</div>
		);
	}

	renderRoutes = () => {
		return (
			<Switch>
				<Route exact path="/" component={Dashboard} />
				<Route exact path="/administration" component={Administration} />
				<Route exact path="/authorizeBrowser" component={AuthorizeBrowser} />
				<Route exact path="/scheduleConfig" component={ScheduleConfig} />
				<Route exact path="/fleetConfig" component={FleetConfig} />
				<Route exact path="/geoTabGroupConfig" component={GeoTabGroupConfig} />
				<Route exact path="/dashboard" component={Dashboard} />
				<Route exact path="/driver/pickReport" component={PickReport} />
				<Route exact path="/driver/report/:action/:reportType/:ticketId?" component={SaveReport} />
				<Route exact path="/driver/report/:action/:driverReportId" component={SaveReport} />

				<Route exact path="/pto/request/dashboard" component={PtoRequestDashboard} />
				<Route exact path="/pto/request/:action(add|addRequired)" component={PtoRequestSave} />
				<Route exact path="/pto/request/view/:ptoRequestId?" component={PtoRequestView} />

				<Route exact path="/pto/approval/dashboard" component={PtoApprovalDashboard} />
				<Route exact path="/pto/approval/approve/:ptoRequestId?" component={PtoApprove} />
				<Route exact path="/pto/exported/dashboard" component={PtoExportedDashboard} />
				<Route exact path="/pto/exported/approve/:ptoRequestId?" component={PtoApprove} />

				<Route exact path="/pto/scheduled/dashboard" component={PtoScheduledDashboard} />

				<Route exact path="/myTickets" component={MyTicketList} />
				<Route exact path="/ticket/list" component={TicketList} />
				<Route exact path="/ticket/billing/list" component={BillingTicketList} />
				<Route exact path="/ticket/advancedSearch" component={TicketAdvancedSearch} />
				<Route exact path="/ticket/:action(add|update)/:ticketId?" component={TicketSave} />
				<Route exact path="/ticketCategory/list" component={TicketCategoryList} />
				<Route
					exact
					path="/ticketCategory/:action(add|update)/:ticketCategoryId?"
					component={TicketCategorySave}
				/>
				<Route exact path="/ticketSchema/list" component={TicketSchemaList} />
				<Route
					exact
					path="/ticketSchema/:action(add|update)/:ticketSchemaId?"
					component={TicketSchemaSave}
				/>
				<Route exact path="/ticketEmail/:action/:ticketId" component={TicketEmailDisplay} />
				<Route exact path="/users" component={Users} />
				<Route exact path="/user/:action(add|update)/:userId?" component={SaveUser} />
				<Route exact path="/user/updateDriver/:userId" component={SaveUserDriver} />
				<Route exact path="/location" component={Location} />
				<Route exact path="/location/:locationTypeId" component={Location} />
				<Route exact path="/location/:locationTypeId/:action" component={SaveLocation} />
				<Route
					exact
					path="/location/:locationTypeId/:action/:locationId"
					component={SaveLocation}
				/>
				<Route exact path="/equipment" component={Equipment} />
				<Route exact path="/equipment/:equipmentTypeId" component={Equipment} />
				<Route exact path="/equipment/:equipmentTypeId/:action" component={SaveEquipment} />
				<Route
					exact
					path="/equipment/:equipmentTypeId/:action/:equipmentId"
					component={SaveEquipment}
				/>
				<Route exact path="/scheduling" component={SchedulingDashboard} />
				<Route exact path="/scheduling/stats" component={SchedulingDashboard} />
				<Route exact path="/scheduling/schedule/:scheduleType" component={SchedulingSchedule} />
				<Route exact path="/reports/drivers" component={DriverReports} />
				<Route
					exact
					path="/reports/drivers/details/:userId/:locationId/:afterDate/:beforeDate"
					component={DriverReportDetails}
				/>
				<Route exact path="/setupDriverRoomSchedule" component={SetupDriverRoomSchedule} />
				<Route exact path="/equipmentAssignment/list" component={EquipmentAssignmentList} />
				<Route
					exact
					path="/equipmentAssignment/:action(add|update|reassign)/:equipmentAssignmentId?"
					component={EquipmentAssignmentSave}
				/>

				<Route exact path="/accounting" component={AccountingDashboard} />
				<Route exact path="/timeClockPermission/list" component={TimeClockPermissionList} />
				<Route
					exact
					path="/timeClockPermission/:action(add|update)/:timeClockPermissionId?"
					component={TimeClockPermissionSave}
				/>
				<Route exact path="/timeClock" component={TimeClockDashboard} />
				<Route exact path="/timeClock/shiftAudit" component={ShiftAudit} />
				<Route exact path="/timeClock/reports" component={TimeClockShiftReports} />
				<Route exact path="/timeClock/exponentExport" component={TimeClockExponentExport} />
				<Route exact path="/timeClock/paycomExport" component={TimeClockPaycomExport} />
				<Route exact path="/clockInAndOut" component={ClockInAndOut} />
				<Route exact path="/accounting/arImporter" component={ArImporter} />
				<Route exact path="/journeyPlan/list" component={JourneyPlans} />
				<Route
					exact
					path="/journeyPlan/:action(add|update)/:journeyPlanId?"
					component={SaveJourneyPlan}
				/>

				<Route exact path="/reports/lateAnalysis" component={LateAnalysis} />
				<Route
					exact
					path="/reports/lateAnalysis/details/:userId/:afterDate/:beforeDate"
					component={LateAnalysisDetails}
				/>

				<Route exact path="/dispatch" component={DispatchDashboard} />
				<Route exact path="/dispatch/notifications" component={MobileNotifications} />
				<Route exact path="/dispatch/pastNotifications" component={PastNotifications} />
				<Route exact path="/dispatch/deviceEvents" component={DeviceEvents} />

				{/* TEST SECTION */}
				<Route exact path="/test/testMobile" component={TestMobile} />

				<Route component={NoMatch} />
			</Switch>
		);
	};
}

Layout.propTypes = {
	classes: PropTypes.object.isRequired,
	logout: PropTypes.func.isRequired,
	width: PropTypes.string,

	//my tickets
	myTickets: PropTypes.array,
	searchMyTickets: PropTypes.func.isRequired,

	//- error
	errorMessages: PropTypes.array,
	clearError: PropTypes.func,

	//- props for generic saving
	onSuccessRedirectTo: PropTypes.string,
	savingStatus: PropTypes.string,
	savingMessage: PropTypes.string,
	savedMessage: PropTypes.string,
	clearSaving: PropTypes.func,

	history: PropTypes.object,
	authUser: PropTypes.object,
};

export default _.flow([withStyles(styles), withWidth(), LayoutContainer, TicketContainer])(Layout);
